// extracted by mini-css-extract-plugin
export default {"container":"BaseNativeAppContainer_container__Tvc4n","content":"BaseNativeAppContainer_content__wTIwu","glass_bg":"BaseNativeAppContainer_glass_bg__XbU2q"};